import { cwslapi } from "../index";

// 获取招募列表
export const getRecruitList = (data) => { 
  return cwslapi({
    url: "/task/getRecruitTaskList",
    method: "post",
    data,
  });
};


// 领取招募奖励
export const getRecruitTaskPrize = (data) => { 
  return cwslapi({
    url: "/task/getRecruitTaskPrize",
    method: "post",
    data,
  });
};

